<script>
  const SERVER_URL="https://hjsite.com:9443";
  let SERVER_TOKEN="";
  export default {
    SERVER_URL, SERVER_TOKEN
  }
</script>



// WEBPACK FOOTER //
// src/Global.vue